import { Component, OnInit } from '@angular/core';
import { LearningResourceService } from '../../../core/services/learning-resource.service';

@Component({
  selector: 'app-users',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss'],
})
export class ResourcesComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Learning Resource-Books',
    },
  ];
  data: any[] = [];
  totalDocs = 0;
  currentPage = 1;
  pageSize = 4;
  searchValue = '';
  exceededLimit = false;

  constructor(private resourceService: LearningResourceService) {}

  ngOnInit(): void {
    this.loadBooks();
  }

  loadBooks(): void {
    this.resourceService
      .getBooks(this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs;
        this.totalDocs = response.totalDocs;
      });
  }

  cancelSearch(): any {
    this.searchValue = '';
    this.currentPage = 1;
    this.loadBooks();
  }

  getBooksBySearch(): void {
    this.resourceService
      .getBooksBySearch(this.searchValue, this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs;
        this.totalDocs = response.totalDocs;
      });
  }

  onCurrentPageDataChange(page: any): void {
    this.currentPage = page;
    this.loadBooks();
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/placeholder_image.jpg';
  }

  serializeToHTML(children: any[]): string {
    const result = children
      .map((node, i) => {
        if (node && typeof node === 'object' && 'text' in node) {
          let truncatedText = node.text.length > 250 ? `${node.text.slice(0, 250)}...` : node.text;
          let text = `<span>${this.escapeHTML(truncatedText)}</span>`;

          if (node.bold) {
            text = `${text}`;
          }

          if (node.code) {
            text = `${text}`;
          }

          if (node.italic) {
            text = `${text}`;
          }

          if (node.underline) {
            text = `${text}`;
          }

          return text;
        }

        if (!node) {
          return null;
        }

        switch (node.type) {
          case 'h1':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h2':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h3':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h4':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h5':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h6':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'blockquote':
            return `<blockquote>${this.serializeToHTML(node.children)}</blockquote>`;
          case 'ul':
            return `<ul>${this.serializeToHTML(node.children)}</ul>`;
          case 'ol':
            return `<ol>${this.serializeToHTML(node.children)}</ol>`;
          case 'li':
            return `<li>${this.serializeToHTML(node.children)}</li>`;
          case 'link':
            return `<p>${this.serializeToHTML(
              node.children
            )}</p>`;

          default:
            return `<p>${this.serializeToHTML(node.children)}</p>`;
        }
      })
      .join('');

    // Truncate the result to 250 characters
    return result.length > 250 ? `${result.slice(0, 250)}...` : result;
  }


  private escapeHTML(text: string): string {
    return text;
  }
}
